import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=1d8911fe&scoped=true"
import script from "./Money.vue?vue&type=script&lang=ts"
export * from "./Money.vue?vue&type=script&lang=ts"
import style0 from "./Money.vue?vue&type=style&index=0&id=1d8911fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8911fe",
  null
  
)

export default component.exports